// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "step-3RDEW";
var _3 = "text-3MPVq";
var _4 = "icon-1lWh5";
export { _1 as "__esModule", _2 as "step", _3 as "text", _4 as "icon" }
export default { "__esModule": _1, "step": _2, "text": _3, "icon": _4 }
